var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "collapsible-block",
    {
      ref: "collapsible",
      attrs: {
        "title-text": _vm.$t("businessOrders.labels.consigneeInformation"),
        "preview-only": ""
      }
    },
    [
      _c(
        "flex-row",
        { staticClass: "flex--no-wrap", attrs: { "column-spacing": "lg" } },
        [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "value-wrapper",
                {
                  attrs: {
                    label: _vm.$t("businessOrders.labels.consigneeName"),
                    "no-wrap": ""
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("valueOrDash")(_vm.businessOrder.customerName)
                      ) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "value-wrapper",
                {
                  attrs: {
                    label: _vm.$t("businessOrders.labels.consigneeAddress"),
                    "no-wrap": ""
                  }
                },
                [
                  _c("consumer-address", {
                    attrs: { order: _vm.businessOrder }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "value-wrapper",
                {
                  attrs: {
                    label: _vm.$t("businessOrders.labels.consigneePhoneNumber"),
                    "no-wrap": ""
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("valueOrDash")(
                          _vm.businessOrder.customerPhoneNumber
                        )
                      ) +
                      "\n            "
                  )
                ]
              ),
              _c(
                "value-wrapper",
                {
                  attrs: {
                    label: _vm.$t("businessOrders.labels.consigneeEmail"),
                    "no-wrap": ""
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("valueOrDash")(_vm.businessOrder.customerEmail)
                      ) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }